import { defineComponent } from "vue";
import useVuelidate from "@vuelidate/core";
import { requiredIf } from "@vuelidate/validators";

import { AllowedTwoFAEnum } from "../../../../../../enums/enums";

import FormSection from "../../../../../../resources-vue/vue-custom-elements/FormSection/FormSection.vue";
import DatePicker from "../../../../../../resources-vue/vue-custom-elements/DatePicker/DatePicker.vue";

export default defineComponent({
    components: {
        FormSection,
        DatePicker
    },

    props: {
        securitySetup: {
            type: Object,
            default: null
        }
    },

    validations() {
        return {
            securitySetup: {
                AllowedTypes: {
                    required: requiredIf(() => this.securitySetup.IsEnabled)
                }
            }
        };
    },

    data(vm) {
        return {
            twoFATypes: [
                {
                    text: "Security Key",
                    value: AllowedTwoFAEnum.SecurityKey,
                    popover:
                        "User's computer device must enable browser or operating system to communicate and register the private key stored on his/her physical security key device (such as a USB drive)"
                },
                {
                    text: "Authenticator App",
                    value: AllowedTwoFAEnum.AuthApp,
                    popover:
                        "User must download and install the Authenticator App from Play Store.  Account setup in the App is also needed."
                },
                {
                    text: "Message and Voice",
                    value: AllowedTwoFAEnum.CallAndText,
                    popover:
                        "All employee profile must have a mobile phone number information that can receive text message or voice phone call. "
                }
            ],
            v$: useVuelidate()
        };
    },

    watch: {
        "securitySetup.IsEnabled"(newValue: boolean) {
            if (!newValue) {
                this.securitySetup.AllowedTypes = [];
            }
        }
    },

    methods: {
        handletype(value: number) {
            if (this.securitySetup.AllowedTypes.includes(value)) {
                this.securitySetup.AllowedTypes = this.securitySetup.AllowedTypes.filter(
                    (val: number) => val !== value
                );
            } else {
                this.securitySetup.AllowedTypes.push(value);
            }
        }
    }
});
